import React from "react";
import classNames from "classnames";
import st from "./index.module.css";

export const SpinnerSize = {
  small: "small",
  large: "large",
} as const;

export const SpinnerColor = {
  white: "white",
  primary: "primary",
} as const;

type SpinnerProps = {
  className?: string;
  size?: keyof typeof SpinnerSize;
  color?: keyof typeof SpinnerColor;
};

export const Spinner: React.FC<SpinnerProps> = ({
  className,
  size = SpinnerSize.large,
  color = SpinnerColor.primary,
}) => (
  <div
    className={classNames(
      st.spinner,
      {
        [st.white]: color === SpinnerColor.white,
        [st.primary]: color === SpinnerColor.primary,
      },
      {
        [st.small]: size === SpinnerSize.small,
        [st.large]: size === SpinnerSize.large,
      },
      className
    )}>
    {new Array(12).fill(null).map((_i, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={idx} />
    ))}
  </div>
);
